export { default } from "./LegalizationMap";
